import { captureException } from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { type PageIdentifier } from 'hb-react/shared/constants/pageIdentifiers';
import { axiosInstance } from 'hb-react/shared/utils/axios';

export const usePageNamesQuery = (names: Array<PageIdentifier>) =>
  useQuery({
    queryKey: ['page-names', names],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get(
          Routes.names_private_frontoffice_page_customizables_path({
            page_identifiers: names,
          }),
        );
        return response.data;
      } catch (error) {
        captureException(error);
        throw error;
      }
    },
    staleTime: ms('15m'),
    gcTime: ms('15m'),
    enabled: names.length > 0,
  });
